import * as React from 'react';
import spinnerLogo from './../../assets/images/spinner.gif'


const Loading = () => (
  <div style={{ paddingTop: 100, paddingBottom:100, textAlign: 'center' }}>
      <img src={spinnerLogo}/>
  </div>
);
export default Loading;